import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["fill"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["transform"];
const _hoisted_4 = ["begin"];
import { watch, computed, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { UiToolbarButton, UiModalSidebar, UiButton, UiLink, UiTooltip, UiError, UiPopperConnector, UiCheckbox, } from '@retailcrm/embed-ui-v1-components/remote';
import { useHost, useOrderCardContext, useField, useRouter } from '@retailcrm/embed-ui';
import { useContext as useUserCurrent } from '@retailcrm/embed-ui-v1-contexts/remote/user/current';
import downloadIconUrl from './assets/logo.svg?url';
const SYSTEM_FONT_STACK = '-apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Roboto, sans-serif';
/* кнопка-триггер */
const ICON_SIZE = 24;
const spinnerColor = '#2563eb';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AiOrderText',
    setup(__props) {
        const primaryBtnText = computed(() => isExistingOrder.value ? t('analyzeEdit') : t('analyze'));
        const DBG = (...a) => {
            if (typeof window !== 'undefined' && localStorage.getItem('AIOT_DEBUG') === '1') {
                console.debug('[AIOT]', ...a);
            }
        };
        const LOG = (...a) => { try {
            console.log('%c[AIOT]', 'color:#2563eb;font-weight:600;', ...a);
        }
        catch { } };
        const GOPEN = (title, collapsed = false) => {
            try {
                const label = '%c' + title;
                const style = 'color:#10b981;font-weight:700;';
                collapsed ? console.groupCollapsed(label, style) : console.group(label, style);
            }
            catch { }
        };
        const GCLOSE = () => { try {
            console.groupEnd();
        }
        catch { } };
        function describeSiteValue(raw) {
            const type = raw === null ? 'null' : Array.isArray(raw) ? 'array' : typeof raw;
            let resolved = null;
            let objKeys = [];
            const candidates = {};
            if (type === 'string') {
                resolved = raw.trim() || null;
            }
            else if (raw && typeof raw === 'object') {
                objKeys = Object.keys(raw);
                const code = (typeof raw.code === 'string' && raw.code.trim()) ? raw.code.trim() : null;
                const id = (typeof raw.id === 'string' && raw.id.trim()) ? raw.id.trim()
                    : (typeof raw.id === 'number' && Number.isFinite(raw.id)) ? String(raw.id) : null;
                const site = (typeof raw.site === 'string' && raw.site.trim()) ? raw.site.trim() : null;
                const name = (typeof raw.name === 'string' && raw.name.trim()) ? raw.name.trim() : null;
                const slug = (typeof raw.slug === 'string' && raw.slug.trim()) ? raw.slug.trim() : null;
                const domain = (typeof raw.domain === 'string' && raw.domain.trim()) ? raw.domain.trim() : null;
                candidates.code = code;
                candidates.id = id;
                candidates.site = site;
                candidates.name = name;
                candidates.slug = slug;
                candidates.domain = domain;
                resolved = code ?? id ?? site ?? name ?? slug ?? null;
            }
            const hostname = (typeof window !== 'undefined') ? window.location.hostname : '';
            const accountSubdomain = hostname.split('.')[0] || '';
            return { type, objKeys, candidates, resolved, hostname, accountSubdomain };
        }
        /** Вывести диагностику site в консоль (красиво) */
        function logSiteDiagnostics(where, raw, resolved, goingToSend) {
            GOPEN(`SITE DIAGNOSTICS: ${where}`);
            const d = describeSiteValue(raw);
            LOG('Field "site" raw value:', raw);
            console.table({
                rawType: d.type,
                objectKeys: (d.objKeys && d.objKeys.length) ? d.objKeys.join(', ') : '(none)',
                candidate_code: d.candidates.code ?? null,
                candidate_id: d.candidates.id ?? null,
                candidate_site: d.candidates.site ?? null,
                candidate_name: d.candidates.name ?? null,
                candidate_slug: d.candidates.slug ?? null,
                candidate_domain: d.candidates.domain ?? null,
                resolvedFromField: resolved ?? null,
                goingToSend: goingToSend ?? '(not-set)',
                locationHostname: d.hostname,
                accountSubdomain: d.accountSubdomain,
            });
            if (goingToSend && d.accountSubdomain && goingToSend !== d.accountSubdomain) {
                LOG('⚠️ Предупреждение: код сайта, который будет отправлен, не совпадает с субдоменом аккаунта из URL. Это может привести к 403 при открытии заказа.');
            }
            GCLOSE();
        }
        const host = useHost();
        const router = useRouter();
        const clientId = ref(detectClientId());
        const currentUserId = ref(detectUserId());
        const userCurrent = useUserCurrent();
        userCurrent?.initialize?.();
        LOG('user/current snapshot at mount:', { id: userCurrent?.id });
        watchEffect(() => {
            const raw = userCurrent?.id;
            LOG('user/current.id →', raw);
            const parsed = typeof raw === 'number' && Number.isFinite(raw)
                ? raw
                : (typeof raw === 'string' && /^\d+$/.test(raw) ? parseInt(raw, 10) : null);
            if (parsed != null)
                currentUserId.value = parsed;
        });
        try {
            const maybeDirect = host?.clientId;
            if (typeof maybeDirect === 'string' && maybeDirect) {
                clientId.value = maybeDirect;
            }
            else if (typeof host?.meta === 'function') {
                const meta = host.meta();
                const metaId = meta && typeof meta.clientId === 'string' ? meta.clientId : null;
                if (metaId)
                    clientId.value = metaId;
                const uid = readUserIdFromMeta(meta);
                if (uid != null)
                    currentUserId.value = uid;
            }
        }
        catch { /* ignore */ }
        function detectClientId() {
            if (typeof window === 'undefined')
                return null;
            try {
                const params = new URLSearchParams(window.location.search);
                return params.get('clientId') || params.get('client_id');
            }
            catch {
                return null;
            }
        }
        function readUserIdFromMeta(meta) {
            if (!meta || typeof meta !== 'object')
                return null;
            const candidates = [
                meta.userId, meta.user?.id, meta.profile?.id, meta.account?.user?.id, meta.currentUser?.id
            ];
            for (const v of candidates) {
                if (typeof v === 'number' && Number.isFinite(v))
                    return v;
                if (typeof v === 'string' && /^\d+$/.test(v))
                    return parseInt(v, 10);
            }
            return null;
        }
        async function tryFetchUserIdViaHost() {
            try {
                const meta = host?.meta ? host.meta() : null;
                const uid = readUserIdFromMeta(meta);
                DBG('meta()', meta, '→ uid:', uid);
                if (uid != null)
                    return uid;
            }
            catch (e) {
                DBG('tryFetchUserIdViaHost error:', e);
            }
            return null;
        }
        function detectUserId() {
            try {
                const w = (typeof window !== 'undefined') ? window : null;
                const uid = w?.__retailcrm__?.user?.id;
                if (typeof uid === 'number')
                    return uid;
            }
            catch { }
            return null;
        }
        async function httpCall(path, payload) {
            let body = payload;
            if (payload == null || typeof payload === 'undefined') {
                body = clientId.value ? { clientId: clientId.value } : undefined;
            }
            else if (typeof payload === 'object' && !Array.isArray(payload)) {
                body = { ...payload };
                if (clientId.value && body.clientId == null) {
                    body.clientId = clientId.value;
                }
            }
            return host.httpCall(path, body);
        }
        const order = useOrderCardContext();
        order.initialize?.();
        const orderIdField = (() => {
            try {
                return useField(order, 'id');
            }
            catch {
                return null;
            }
        })();
        const isExistingOrder = computed(() => Boolean(orderIdField?.value));
        const opened = ref(false);
        const text = ref('');
        const textareaHovered = ref(false);
        const textareaFocused = ref(false);
        const isHelpHovered = ref(false);
        const loading = ref(false);
        const error = ref(null);
        const result = ref('');
        const orderUrl = ref('');
        const isRouting = ref(false);
        const fillOnly = ref(false);
        const fillNote = ref('');
        watch(fillOnly, () => {
            resetPendingState();
        });
        const originalSnapshot = ref(null);
        const pendingAi = ref(null);
        const pendingChangedKeys = ref([]);
        const pendingItems = ref([]);
        const pendingFields = ref([]);
        const { t, n, locale } = useI18n();
        const modalTitle = computed(() => isExistingOrder.value ? t('titleEdit') : t('title'));
        const contragentKeys = [
            'contragentType',
            'legalName',
            'legalAddress',
            'INN',
            'KPP',
            'OGRN',
            'BIK',
            'bank',
            'bankAddress',
            'corrAccount',
            'bankAccount',
        ];
        function errToString(e) {
            if (e instanceof Error)
                return e.message;
            try {
                return JSON.stringify(e);
            }
            catch {
                return String(e);
            }
        }
        function safeParseJson(s) {
            try {
                return JSON.parse(s);
            }
            catch {
                return null;
            }
        }
        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        async function waitForUserIdFromContext(timeoutMs = 1500) {
            const started = Date.now();
            while (Date.now() - started < timeoutMs) {
                const raw = userCurrent?.id;
                const id = typeof raw === 'number' && Number.isFinite(raw)
                    ? raw
                    : (typeof raw === 'string' && /^\d+$/.test(raw) ? parseInt(raw, 10) : null);
                if (id != null)
                    return id;
                await sleep(100);
            }
            return null;
        }
        function accountOrigin() {
            try {
                const ao = window.location?.ancestorOrigins;
                if (ao && ao.length)
                    return ao[ao.length - 1];
            }
            catch { }
            try {
                if (document.referrer)
                    return new URL(document.referrer).origin;
            }
            catch { }
            try {
                const meta = host?.meta?.();
                const base = meta?.accountUrl || meta?.origin || meta?.baseUrl;
                if (base)
                    return new URL(base).origin;
            }
            catch { }
            return null;
        }
        function toAccountAbs(pathOrRel) {
            const origin = accountOrigin();
            return origin ? new URL(pathOrRel, origin).toString() : pathOrRel;
        }
        function withBust(absUrl) {
            try {
                const origin = accountOrigin() || (typeof window !== 'undefined' ? window.location.origin : 'https://dummy');
                const u = new URL(absUrl, origin);
                u.searchParams.set('_aiot', String(Date.now()));
                return u.toString();
            }
            catch {
                const sep = absUrl.includes('?') ? '&' : '?';
                return absUrl + sep + '_aiot=' + Date.now();
            }
        }
        async function fetchManagerIdFromServer() {
            try {
                const resp = await httpCall('/api/ai/whoami');
                const raw = resp?.body || '';
                DBG('httpCall ← /api/ai/whoami status:', resp?.status, 'body:', raw);
                const json = safeParseJson(raw) || {};
                const uid = json?.userId;
                if (typeof uid === 'number' && Number.isFinite(uid))
                    return uid;
                if (typeof uid === 'string' && /^\d+$/.test(uid))
                    return parseInt(uid, 10);
            }
            catch (e) {
                DBG('fetchManagerIdFromServer error:', e);
            }
            return null;
        }
        function safeSet(path, value) {
            try {
                const fld = useField(order, path);
                if (!fld || typeof fld !== 'object' || !('value' in fld))
                    return false;
                try {
                    fld.value = value;
                }
                catch {
                    return false;
                }
                return true;
            }
            catch {
                return false;
            }
        }
        function setOneOf(paths, value) {
            for (const p of paths)
                if (safeSet(p, value))
                    return true;
            return false;
        }
        function readField(paths) {
            const variants = Array.isArray(paths) ? paths : [paths];
            for (const p of variants) {
                try {
                    const fld = useField(order, p);
                    if (fld && typeof fld === 'object' && 'value' in fld) {
                        return fld.value;
                    }
                }
                catch { /* ignore */ }
            }
            return undefined;
        }
        function snapshotOrder() {
            const snapshot = {
                customerComment: readField('customerComment') ?? null,
                email: readField(['customer.email', 'email']) ?? null,
                phone: readField(['phone', 'customer.phone', 'customer.phones.0.number']) ?? null,
                firstName: readField(['firstName', 'customer.firstName']) ?? null,
                lastName: readField(['lastName', 'customer.lastName']) ?? null,
                patronymic: readField(['patronymic', 'customer.patronymic']) ?? null,
                deliveryAddress: readField([
                    'delivery.address.text',
                    'delivery.addressText',
                    'delivery.address',
                    'delivery.address.fullAddress',
                ]) ?? null,
                customerType: readField('customer.type') ?? null,
                contragent: {},
            };
            // соберём customer.* из формы, если там что-то есть
            const customerBlock = {};
            const cEmail = readField('customer.email');
            const cFirst = readField('customer.firstName');
            const cLast = readField('customer.lastName');
            const cPatr = readField('customer.patronymic');
            const cPhones = readField('customer.phones');
            if (cEmail)
                customerBlock.email = cEmail;
            if (cFirst)
                customerBlock.firstName = cFirst;
            if (cLast)
                customerBlock.lastName = cLast;
            if (cPatr)
                customerBlock.patronymic = cPatr;
            if (Array.isArray(cPhones) && cPhones.length)
                customerBlock.phones = cPhones;
            if (Object.keys(customerBlock).length) {
                ;
                snapshot.customer = customerBlock;
            }
            // Контрагент 
            for (const key of contragentKeys) {
                const val = readField([`contragent.${key}`, `company.${key}`]);
                snapshot.contragent[key] = val != null ? String(val) : null;
            }
            try {
                const cf = readField('customFields');
                if (cf && typeof cf === 'object' && !Array.isArray(cf)) {
                    ;
                    snapshot.customFields = { ...cf };
                }
            }
            catch { }
            // site + items 
            try {
                const site = readField('site');
                if (site != null)
                    snapshot.site = site;
            }
            catch { }
            try {
                const items = readField('items');
                if (Array.isArray(items) && items.length)
                    snapshot.items = items;
            }
            catch { }
            return snapshot;
        }
        function diffAiWithSnapshot(ai, origin) {
            const changedKeys = new Set();
            const patch = {};
            const contragentPatch = {};
            const customerPatch = {};
            const comment = (ai.comment ?? '').trim();
            if (comment && comment !== (origin.customerComment ?? '')) {
                patch.customerComment = comment;
                changedKeys.add('customerComment');
            }
            const contactInfo = ai.contact_info || {};
            const cp = ai.contact_person || {};
            const phone = (contactInfo.phone || cp.phone || '').trim();
            if (phone && phone !== (origin.phone ?? '')) {
                patch.phone = phone;
                customerPatch.phones = [{ number: phone }];
                changedKeys.add('phone');
                changedKeys.add('customer');
            }
            const email = (contactInfo.email || '').trim();
            if (email && email !== (origin.email ?? '')) {
                patch.email = email;
                changedKeys.add('email');
            }
            const person = ai.person || {};
            const firstName = (person.first_name || '').trim();
            if (firstName && firstName !== (origin.firstName ?? '')) {
                patch.firstName = firstName;
                changedKeys.add('firstName');
            }
            const lastName = (person.last_name || '').trim();
            if (lastName && lastName !== (origin.lastName ?? '')) {
                patch.lastName = lastName;
                changedKeys.add('lastName');
            }
            const patronymic = (person.middle_name || '').trim();
            if (patronymic && patronymic !== (origin.patronymic ?? '')) {
                patch.patronymic = patronymic;
                changedKeys.add('patronymic');
            }
            const deliveryAddress = (ai.delivery_address || '').trim();
            if (deliveryAddress && deliveryAddress !== (origin.deliveryAddress ?? '')) {
                patch.deliveryAddress = deliveryAddress;
                changedKeys.add('delivery');
            }
            const bank = ai.bank_details || {};
            const maybeAssignContragent = (key, value) => {
                const normalized = (value || '').trim();
                if (!normalized)
                    return;
                if (normalized !== (origin.contragent[key] ?? '')) {
                    contragentPatch[key] = normalized;
                    changedKeys.add('contragent');
                }
            };
            maybeAssignContragent('legalName', ai.company_name);
            maybeAssignContragent('legalAddress', ai.legal_address);
            maybeAssignContragent('INN', ai.INN);
            maybeAssignContragent('KPP', ai.KPP);
            maybeAssignContragent('OGRN', ai.OGRN);
            maybeAssignContragent('BIK', bank.BIC);
            maybeAssignContragent('bank', bank.bank_name);
            maybeAssignContragent('bankAddress', bank.city);
            maybeAssignContragent('corrAccount', bank.correspondent_account);
            maybeAssignContragent('bankAccount', bank.account_number);
            const hasCorporateSigns = Boolean(ai.company_name || ai.INN || ai.KPP || ai.OGRN ||
                bank.account_number || bank.bank_name || bank.BIC || bank.correspondent_account);
            if (hasCorporateSigns && origin.customerType !== 'customer_corporate') {
                customerPatch.type = 'customer_corporate';
                changedKeys.add('customer');
            }
            const items = Array.isArray(ai.product) ? ai.product.filter(p => (p.productName || '').trim()) : [];
            if (items.length) {
                changedKeys.add('items');
            }
            if (Object.keys(contragentPatch).length) {
                patch.contragent = Object.fromEntries(Object.entries(contragentPatch));
            }
            if (Object.keys(customerPatch).length) {
                patch.customerType = customerPatch.type ?? origin.customerType ?? null;
            }
            return {
                changedKeys: Array.from(changedKeys),
                contragent: contragentPatch,
                customer: customerPatch,
                patch,
                items,
            };
        }
        function applyPatchToForm(diff) {
            pendingFields.value = [];
            const addPendingField = (key, value, customLabel) => {
                if (value == null || value === '')
                    return;
                const text = typeof value === 'string'
                    ? value
                    : Array.isArray(value)
                        ? value.map(v => (typeof v === 'string' ? v : JSON.stringify(v))).join(', ')
                        : typeof value === 'object'
                            ? JSON.stringify(value)
                            : String(value);
                if (!text)
                    return;
                pendingFields.value.push({
                    key,
                    label: customLabel || resolvePendingLabel(key),
                    value: text,
                });
            };
            const applyOrStore = (paths, value, key) => {
                if (value == null || value === '')
                    return;
                if (!setOneOf(paths, value)) {
                    addPendingField(key, value);
                }
            };
            if ('customerComment' in diff.patch && diff.patch.customerComment != null) {
                if (!setOneOf(['customerComment'], diff.patch.customerComment)) {
                    addPendingField('customerComment', diff.patch.customerComment, t('pendingField.customerComment'));
                }
            }
            if ('email' in diff.patch && diff.patch.email != null) {
                applyOrStore(['email', 'customer.email'], diff.patch.email, 'email');
            }
            if ('phone' in diff.patch && diff.patch.phone != null) {
                applyOrStore(['phone', 'customer.phone', 'customer.phones.0.number'], diff.patch.phone, 'phone');
            }
            if ('firstName' in diff.patch && diff.patch.firstName != null) {
                applyOrStore(['firstName', 'customer.firstName'], diff.patch.firstName, 'firstName');
            }
            if ('lastName' in diff.patch && diff.patch.lastName != null) {
                applyOrStore(['lastName', 'customer.lastName'], diff.patch.lastName, 'lastName');
            }
            if ('patronymic' in diff.patch && diff.patch.patronymic != null) {
                applyOrStore(['patronymic', 'customer.patronymic'], diff.patch.patronymic, 'patronymic');
            }
            if ('deliveryAddress' in diff.patch && diff.patch.deliveryAddress) {
                applyOrStore(['delivery.address.text', 'delivery.addressText', 'delivery.address', 'delivery.address.fullAddress'], diff.patch.deliveryAddress, 'deliveryAddress');
            }
            if (Object.keys(diff.contragent).length) {
                for (const [key, value] of Object.entries(diff.contragent)) {
                    if (!setOneOf([`contragent.${key}`, `company.${key}`], value)) {
                        addPendingField(`contragent.${key}`, value, resolvePendingLabel(`contragent.${key}`));
                    }
                }
            }
            if (diff.customer.type) {
                applyOrStore(['customer.type'], diff.customer.type, 'customerType');
            }
            if (Array.isArray(diff.customer.phones) && diff.customer.phones.length) {
                const number = diff.customer.phones[0]?.number;
                if (number && !setOneOf(['customer.phones.0.number', 'phone'], number)) {
                    addPendingField('customer.phone', number, t('pendingField.customerPhone'));
                }
            }
        }
        function resolvePendingLabel(key) {
            const map = {
                customerComment: t('pendingField.customerComment'),
                email: t('pendingField.email'),
                phone: t('pendingField.phone'),
                firstName: t('pendingField.firstName'),
                lastName: t('pendingField.lastName'),
                patronymic: t('pendingField.patronymic'),
                deliveryAddress: t('pendingField.deliveryAddress'),
                customerType: t('pendingField.customerType'),
                'customer.phone': t('pendingField.customerPhone'),
                'contragent.contragentType': t('pendingField.contragentType'),
                'contragent.legalName': t('pendingField.legalName'),
                'contragent.legalAddress': t('pendingField.legalAddress'),
                'contragent.INN': t('pendingField.INN'),
                'contragent.KPP': t('pendingField.KPP'),
                'contragent.OGRN': t('pendingField.OGRN'),
                'contragent.BIK': t('pendingField.BIK'),
                'contragent.bank': t('pendingField.bank'),
                'contragent.bankAddress': t('pendingField.bankAddress'),
                'contragent.corrAccount': t('pendingField.corrAccount'),
                'contragent.bankAccount': t('pendingField.bankAccount'),
            };
            return map[key] || key;
        }
        function resetPendingState() {
            pendingAi.value = null;
            pendingChangedKeys.value = [];
            pendingItems.value = [];
            pendingFields.value = [];
            fillNote.value = fillOnly.value ? t('fillOnlyHint') : '';
        }
        function pendingItemKey(item) {
            const qty = item.quantity ?? 1;
            const price = item.initialPrice ?? 0;
            return `${item.productName || ''}-${qty}-${price}`;
        }
        function formatPendingItem(item) {
            const qty = item.quantity ?? 1;
            const price = item.initialPrice ?? 0;
            const name = item.productName || t('itemsTitle');
            if (price) {
                const formatted = new Intl.NumberFormat(locale.value, {
                    style: 'currency',
                    currency: 'RUB',
                    maximumFractionDigits: 0,
                }).format(price);
                return `${name} ×${qty} — ${formatted}`;
            }
            return `${name} ×${qty}`;
        }
        function onTextChange(e) {
            const el = e.target;
            const v = el ? el.value : '';
            text.value = v;
        }
        function onKeydown(e) {
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter' && !loading.value) {
                e.preventDefault();
                send();
            }
        }
        /** перейти по url в ТЕКУЩЕЙ вкладке (без использования host API) */
        function navigateSameTab(url) {
            isRouting.value = true;
            try {
                window.location.assign(url);
                return true;
            }
            catch {
                try {
                    window.location.href = url;
                    return true;
                }
                catch {
                    return false;
                }
            }
        }
        // Нормализация id заказа для роутера
        function normalizeOrderId(raw) {
            if (raw == null)
                return null;
            if (typeof raw === 'number' && Number.isFinite(raw))
                return raw;
            if (typeof raw === 'string' && /^\d+$/.test(raw.trim()))
                return parseInt(raw.trim(), 10);
            return null;
        }
        // Генерация ссылки на редактирование заказа через системный роутер
        function generateOrderEditHref(id) {
            const numericId = normalizeOrderId(id);
            if (numericId != null) {
                try {
                    const r = router?.value ?? router;
                    if (r && typeof r.generate === 'function') {
                        // официальный роут: crm_orders_edit
                        return r.generate('crm_orders_edit', { id: numericId });
                    }
                }
                catch (e) {
                    DBG('router.generate(\"crm_orders_edit\") failed, fallback to path:', e);
                }
            }
            // Фолбэк на старый относительный путь (на случай, если роутер вдруг не работает)
            const sid = String(id).trim();
            return sid ? `/orders/${sid}/edit` : '/orders';
        }
        // Программный переход на страницу редактирования заказа
        function goToOrderEdit(id) {
            isRouting.value = true;
            const numericId = normalizeOrderId(id);
            const hasGoTo = typeof host?.goTo === 'function';
            LOG('goToOrderEdit():', { id, numericId, hasGoTo });
            // Основной путь — официальный API CRM
            if (numericId != null && hasGoTo) {
                try {
                    ;
                    host.goTo('crm_orders_edit', { id: numericId });
                    return;
                }
                catch (e) {
                    DBG('host.goTo("crm_orders_edit") failed:', e);
                }
            }
            const href = generateOrderEditHref(id);
            try {
                window.location.assign(href);
            }
            catch {
                // ignore
            }
        }
        function openHelpLink() {
            const url = 'https://retailcrm.aiload.ru/support/';
            try {
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            catch {
                try {
                    window.open(url, '_blank', 'noopener');
                }
                catch {
                    try {
                        window.location.assign(url);
                    }
                    catch {
                    }
                }
            }
        }
        /** жёсткое обновление страницы (или переход на тот же заказ) */
        function hardReloadCurrent(url) {
            isRouting.value = true;
            try {
                if (url && typeof url === 'string') {
                    window.location.assign(url);
                }
                else {
                    window.location.reload();
                }
            }
            catch {
                // ignore
            }
        }
        function extractOrderIdFromUrl(url) {
            try {
                const u = new URL(url, (typeof window !== 'undefined') ? window.location.origin : 'https://dummy');
                const m = u.pathname.match(/\/orders\/(\d+)(?:\/|$)/);
                return m ? m[1] : null;
            }
            catch {
                return null;
            }
        }
        function buildAccountRelativeOrderEdit(id) {
            const sid = String(id).trim();
            return sid ? `/orders/${sid}/edit` : '/orders';
        }
        async function open() {
            opened.value = true;
            error.value = null;
            result.value = '';
            orderUrl.value = '';
            DBG('open(): currentUserId BEFORE =', currentUserId.value);
            GOPEN('OPEN: context snapshot', true);
            LOG('user/current.id:', userCurrent?.id);
            LOG('host.meta():', host?.meta ? host.meta() : null);
            LOG('__retailcrm__.user?.id:', window?.__retailcrm__?.user?.id);
            GCLOSE();
            // 1) попытка вытащить из host.meta()
            if (currentUserId.value == null) {
                try {
                    const meta = host?.meta ? host.meta() : null;
                    const uid = readUserIdFromMeta(meta);
                    DBG('meta()', meta, '→ uid:', uid);
                    if (uid != null)
                        currentUserId.value = uid;
                }
                catch (e) {
                    DBG('open(): meta() read failed:', e);
                }
            }
            // 2) надёжный бэкенд-фолбэк
            if (currentUserId.value == null) {
                const uid = await fetchManagerIdFromServer();
                DBG('open(): server whoami →', uid);
                if (uid != null)
                    currentUserId.value = uid;
            }
            DBG('open(): currentUserId AFTER =', currentUserId.value);
            if (!isExistingOrder.value) {
                fillOnly.value = false;
            }
            if (isExistingOrder.value) {
                originalSnapshot.value = snapshotOrder();
            }
            resetPendingState();
        }
        function close() {
            opened.value = false;
        }
        async function applyPendingItems() {
            if (!isExistingOrder.value) {
                return;
            }
            const prevFillOnly = fillOnly.value;
            try {
                fillOnly.value = false;
                await send();
                try {
                    typeof resetPendingState === 'function' && resetPendingState();
                }
                catch (e) {
                    DBG('resetPendingState failed:', e);
                }
            }
            finally {
                fillOnly.value = prevFillOnly;
            }
        }
        async function send() {
            if (!text.value.trim()) {
                error.value = t('enterTextError') || 'Введите текст';
                return;
            }
            // Вспомогательные эвристики
            const hasCorporateSignalsInText = (s) => {
                const src = s.toLowerCase();
                return [
                    'инн', 'кпп', 'огрн', 'ооо', 'ип ', 'ао ', 'пao ', 'зао ',
                    'юр.адрес', 'юридический адрес', 'р/с', 'р/c', 'расчетный счет',
                    'бик', 'корр.счет', 'к/с', 'корреспондентский счёт', 'юрлицо', 'юр. лицо'
                ].some(tok => src.includes(tok));
            };
            const buildHints = () => ({
                preferCorporate: hasCorporateSignalsInText(text.value),
                // можно расширять при необходимости
            });
            // Подготовка состояния
            GOPEN('AI Order: SEND');
            loading.value = true;
            error.value = null;
            result.value = '';
            orderUrl.value = '';
            isRouting.value = false;
            // STEP 1: Определяем managerId максимально надежно
            GOPEN('STEP 1: Resolve managerId');
            let userCurrentId = null;
            {
                const raw = userCurrent?.id;
                userCurrentId =
                    typeof raw === 'number' && Number.isFinite(raw)
                        ? raw
                        : (typeof raw === 'string' && /^\d+$/.test(raw) ? parseInt(raw, 10) : null);
            }
            if (userCurrentId == null) {
                LOG('user/current.id is not ready yet, waiting…');
                userCurrentId = await waitForUserIdFromContext(1500);
                LOG('user/current.id after wait:', userCurrentId);
            }
            let fromHostMeta = null;
            let fromApiWhoami = null;
            if (currentUserId.value == null && userCurrentId != null) {
                currentUserId.value = userCurrentId;
            }
            if (currentUserId.value == null) {
                const uidHost = await tryFetchUserIdViaHost();
                if (uidHost != null) {
                    currentUserId.value = uidHost;
                    fromHostMeta = uidHost;
                }
            }
            if (currentUserId.value == null) {
                const uidApi = await fetchManagerIdFromServer();
                if (uidApi != null) {
                    currentUserId.value = uidApi;
                    fromApiWhoami = uidApi;
                }
            }
            LOG('Manager sources:', {
                userCurrentId,
                fromHostMeta,
                fromApiWhoami,
                finalManagerId: currentUserId.value
            });
            GCLOSE(); // STEP 1
            // Утилита: вытащить менеджера и сайт из формы (актуально для create)
            const extractManagerAndSiteFromForm = () => {
                const candidates = {
                    'managerId': readField('managerId'),
                    'manager.id': readField('manager.id'),
                    'manager': readField('manager'),
                    'ownerId': readField('ownerId'),
                    'responsibleId': readField('responsibleId'),
                };
                let selectedManagerId = null;
                for (const [, v] of Object.entries(candidates)) {
                    if (typeof v === 'number' && Number.isFinite(v)) {
                        selectedManagerId = v;
                        break;
                    }
                    if (typeof v === 'string' && /^\d+$/.test(v)) {
                        selectedManagerId = parseInt(v, 10);
                        break;
                    }
                    if (v && typeof v === 'object') {
                        const vid = (typeof v.id === 'number' && Number.isFinite(v.id)) ? v.id
                            : (typeof v.id === 'string' && /^\d+$/.test(v.id)) ? parseInt(v.id, 10)
                                : null;
                        if (vid != null) {
                            selectedManagerId = vid;
                            break;
                        }
                    }
                }
                const rawSite = readField('site');
                let siteCode = null;
                if (typeof rawSite === 'string' && rawSite.trim()) {
                    siteCode = rawSite.trim();
                }
                else if (rawSite && typeof rawSite === 'object') {
                    const obj = rawSite;
                    siteCode =
                        (typeof obj.code === 'string' && obj.code.trim()) ? obj.code.trim()
                            : (typeof obj.id === 'string' && obj.id.trim()) ? obj.id.trim()
                                : (typeof obj.site === 'string' && obj.site.trim()) ? obj.site.trim()
                                    : (typeof obj.name === 'string' && obj.name.trim()) ? obj.name.trim()
                                        : (typeof obj.slug === 'string' && obj.slug.trim()) ? obj.slug.trim()
                                            : null;
                }
                GOPEN('STEP 2: Probe form (manager/site)');
                LOG('Raw manager candidates:', candidates);
                logSiteDiagnostics('from form', rawSite, siteCode);
                console.table({
                    managerFromForm: selectedManagerId ?? null,
                    siteFromForm: siteCode ?? null
                });
                GCLOSE();
                return { selectedManagerId, siteCode, rawSite };
            };
            // Ветка «только заполнить форму» (без создания/редактирования заказа)
            if (fillOnly.value) {
                try {
                    const trimmed = text.value.trim();
                    GOPEN('STEP 3 (fillOnly): Start analyze');
                    LOG('Request:', { endpoint: '/api/ai/analyze/start', textLength: trimmed.length });
                    const startResp = await httpCall('/api/ai/analyze/start', { text: trimmed, hints: buildHints() });
                    const startRaw = startResp?.body || '';
                    const startJson = safeParseJson(startRaw) || {};
                    if (startResp?.status !== 200 || !startJson?.jobId) {
                        const msg = startRaw || `HTTP ${startResp?.status}`;
                        throw new Error(`Analyze start failed: ${msg}`);
                    }
                    const jobId = String(startJson.jobId);
                    appendResultBlock('waiting', { stage: 'waiting', status: 'running', jobId });
                    LOG('Job started:', jobId);
                    GCLOSE(); // STEP 3
                    let ai = null;
                    const startedAt = Date.now();
                    GOPEN('STEP 4 (fillOnly): Polling status');
                    while (true) {
                        const stResp = await httpCall('/api/ai/analyze/status', { jobId });
                        const stRaw = stResp?.body || '';
                        const stJson = safeParseJson(stRaw) || {};
                        if (stResp?.status !== 200) {
                            const msg = stRaw || `HTTP ${stResp?.status}`;
                            throw new Error(`Analyze status failed: ${msg}`);
                        }
                        if (stJson?.done) {
                            if (stJson?.ok && stJson?.ai) {
                                ai = stJson.ai;
                                const origin = originalSnapshot.value || snapshotOrder();
                                const diff = diffAiWithSnapshot(ai, origin);
                                applyPatchToForm(diff);
                                pendingAi.value = ai;
                                pendingChangedKeys.value = diff.changedKeys;
                                pendingItems.value = diff.items;
                                appendResultBlock('ai', ai);
                                appendResultBlock('changedKeys', diff.changedKeys);
                                if (diff.items.length)
                                    appendResultBlock('itemsPending', diff.items);
                                fillNote.value = diff.changedKeys.length || diff.items.length
                                    ? t('fillOnlyAppliedNote')
                                    : t('fillOnlyNoChanges');
                                LOG('Analyze done:', { changedKeys: diff.changedKeys, itemsCount: diff.items?.length || 0 });
                            }
                            else {
                                throw new Error(String(stJson?.error || 'Analyze failed'));
                            }
                            break;
                        }
                        if (Date.now() - startedAt > 120000)
                            throw new Error('Timeout while waiting the analyze result');
                        await sleep(800);
                    }
                    GCLOSE(); // STEP 4
                    if (!ai)
                        throw new Error('Analyze produced empty payload');
                    LOG('STEP 5 (fillOnly): Complete ✅');
                }
                catch (e) {
                    if (!isRouting.value)
                        error.value = errToString(e);
                }
                finally {
                    loading.value = false;
                    GCLOSE(); // AI Order: SEND
                }
                return;
            }
            // Полный цикл: анализ → создать/обновить заказ в RetailCRM
            try {
                const payload = { text: text.value.trim(), hints: buildHints() };
                const orderId = orderIdField?.value ? String(orderIdField.value) : null;
                if (orderId)
                    payload.orderId = orderId;
                if (currentUserId.value != null)
                    payload.managerId = currentUserId.value;
                let selectedManagerId = null;
                let siteCode = null;
                let siteRawForLog = null;
                if (!orderId) {
                    // создаём новый — пробросим снимок формы и сайт/менеджера, если есть
                    const formSnapshot = snapshotOrder();
                    payload.formSnapshot = formSnapshot;
                    const { selectedManagerId: mId, siteCode: sCode, rawSite } = extractManagerAndSiteFromForm();
                    selectedManagerId = mId;
                    siteCode = sCode;
                    siteRawForLog = rawSite;
                    if (siteCode)
                        payload.orderSite = siteCode;
                    if (selectedManagerId != null)
                        payload.managerId = selectedManagerId;
                    GOPEN('STEP 3 (create): Start job');
                    console.table({
                        orderId: null,
                        managerFromContext: currentUserId.value ?? null,
                        managerFromForm: selectedManagerId ?? null,
                        managerFinal: payload.managerId ?? null,
                        siteFromForm: siteCode ?? null,
                        preferCorporate: payload.hints?.preferCorporate ?? false
                    });
                    logSiteDiagnostics('before start', siteRawForLog, siteCode, payload.orderSite ?? null);
                    LOG('Raw site field:', siteRawForLog);
                    appendResultBlock('startPayload', {
                        orderId: null,
                        orderSite: payload.orderSite ?? null,
                        managerId: payload.managerId ?? null,
                        hints: payload.hints
                    });
                }
                else {
                    // обновляем существующий — бэкенд сам возьмёт сайт заказа
                    GOPEN('STEP 3 (update): Start job');
                    console.table({
                        orderId,
                        managerFromContext: currentUserId.value ?? null,
                        managerFinal: payload.managerId ?? null,
                        preferCorporate: payload.hints?.preferCorporate ?? false
                    });
                    appendResultBlock('startPayload', {
                        orderId, managerId: payload.managerId, hints: payload.hints
                    });
                }
                LOG('Request:', { endpoint: '/api/ai/analyze-and-create/start', textLength: payload.text.length });
                const startResp = await httpCall('/api/ai/analyze-and-create/start', payload);
                const startRaw = startResp?.body || '';
                const startJson = safeParseJson(startRaw) || {};
                if (startResp?.status !== 200 || !startJson?.jobId) {
                    const msg = startRaw || `HTTP ${startResp?.status}`;
                    throw new Error(`Start failed: ${msg}`);
                }
                const jobId = String(startJson.jobId);
                appendResultBlock('started', { stage: 'started', jobId });
                LOG('Job started:', jobId);
                GCLOSE(); // STEP 3
                const startedAt = Date.now();
                GOPEN('STEP 4: Polling status');
                while (true) {
                    const stResp = await httpCall('/api/ai/analyze-and-create/status', { jobId });
                    const stRaw = stResp?.body || '';
                    const stJson = safeParseJson(stRaw) || {};
                    if (stResp?.status !== 200) {
                        const msg = stRaw || `HTTP ${stResp?.status}`;
                        throw new Error(`Status failed: ${msg}`);
                    }
                    if (stJson?.done) {
                        if (stJson.ok && (stJson.orderId || stJson.url)) {
                            // 1. Берём id заказа из ответа (предпочтительно) или парсим из абсолютного URL
                            const absFromResp = typeof stJson.url === 'string' ? stJson.url : '';
                            const idFromResp = stJson.orderId ?? extractOrderIdFromUrl(absFromResp);
                            const numericId = normalizeOrderId(idFromResp ?? null);
                            // 2. Строим ссылку для кнопки "Открыть созданный заказ"
                            let hrefPath = '/orders';
                            if (numericId != null) {
                                // официальный путь через роутер (crm_orders_edit),
                                // с фолбэком на /orders/:id/edit
                                hrefPath = generateOrderEditHref(numericId);
                            }
                            else if (absFromResp) {
                                // если id нет, но есть абсолютный url от бэка — используем его
                                hrefPath = absFromResp;
                            }
                            const hrefAbs = toAccountAbs(hrefPath);
                            orderUrl.value = hrefAbs;
                            console.table({
                                resultUrlAbs: absFromResp || '(n/a)',
                                resultHref: hrefPath,
                                orderId: numericId ?? null,
                                mode: stJson.mode ?? null,
                                siteUsed: siteCode || '(RetailCRM default)',
                            });
                            // 3. Если редактировали УЖЕ СУЩЕСТВУЮЩИЙ заказ — остаёмся на этом заказе
                            if (isExistingOrder.value) {
                                const rawCurrent = orderIdField?.value ?? idFromResp ?? null;
                                const currentNumeric = normalizeOrderId(rawCurrent);
                                if (currentNumeric != null) {
                                    // host.goTo('crm_orders_edit', { id }) + фолбэк
                                    goToOrderEdit(currentNumeric);
                                    return;
                                }
                                // Нет нормального id — просто перезагрузим страницу
                                if (orderUrl.value) {
                                    hardReloadCurrent(orderUrl.value);
                                }
                                else {
                                    hardReloadCurrent();
                                }
                                return;
                            }
                            // 4. Создание: best-effort — проставим managerId, если вдруг не выставился
                            try {
                                const createdId = numericId != null ? String(numericId) : '';
                                const fallbackManager = (selectedManagerId != null
                                    ? selectedManagerId
                                    : (currentUserId.value ?? null));
                                if (createdId && fallbackManager != null) {
                                    await httpCall('/api/ai/order/apply', {
                                        orderId: createdId,
                                        changedKeys: ['managerId'],
                                        pendingFields: [{ key: 'managerId', value: String(fallbackManager) }],
                                    });
                                    LOG('Fallback managerId applied:', { orderId: createdId, managerId: fallbackManager });
                                }
                            }
                            catch {
                                // best-effort — ошибки молча игнорируем
                            }
                            // 5. Навигация после СОЗДАНИЯ заказа
                            GCLOSE(); // STEP 4
                            if (numericId != null) {
                                // основной путь — через host.goTo / router
                                goToOrderEdit(numericId);
                            }
                            else if (!navigateSameTab(orderUrl.value || hrefAbs)) {
                                // запасной вариант
                                hardReloadCurrent(orderUrl.value || hrefAbs);
                            }
                            LOG('STEP 5: Navigation (create) ✅');
                            GCLOSE();
                            return;
                        }
                        else if (stJson.error) {
                            throw new Error(String(stJson.error));
                        }
                        break;
                    }
                    if (Date.now() - startedAt > 120000) {
                        throw new Error('Timeout while waiting the result');
                    }
                    await sleep(1000);
                }
                GCLOSE(); // STEP 4
            }
            catch (e) {
                if (!isRouting.value)
                    error.value = errToString(e);
            }
            finally {
                loading.value = false;
                GCLOSE();
            }
        }
        function appendResultBlock(title, obj) {
            const current = result.value ? safeParseJson(result.value) : null;
            const payload = current && typeof current === 'object'
                ? { ...current, [title]: obj }
                : { [title]: obj };
            result.value = JSON.stringify(payload, null, 2);
        }
        /* Стили  */
        const triggerBtnStyle = computed(() => ({
            display: 'inline-flex',
            alignItems: 'center',
        }));
        const triggerContentStyle = computed(() => ({
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            lineHeight: 1,
        }));
        const triggerIconStyle = computed(() => ({
            width: `${ICON_SIZE}px`,
            height: `${ICON_SIZE}px`,
            minWidth: `${ICON_SIZE}px`,
            minHeight: `${ICON_SIZE}px`,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 0,
            verticalAlign: 'middle',
        }));
        const toggleRowStyle = computed(() => ({
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            userSelect: 'none',
            marginTop: '8px',
            marginBottom: '8px',
        }));
        const toggleTextStyle = computed(() => ({
            fontSize: '14px',
            color: '#111827',
        }));
        const helpList = computed(() => {
            const src = [
                t('help.list.contacts'),
                t('help.list.company'),
                t('help.list.items'),
                t('help.list.address'),
            ];
            return src.map((s) => {
                const str = String(s || '');
                const idx = str.indexOf(':');
                return idx === -1
                    ? { label: str, tail: '' }
                    : { label: str.slice(0, idx), tail: str.slice(idx + 1).trim() };
            });
        });
        const helpIconSvgStyle = computed(() => ({
            width: '18px',
            height: '18px',
            display: 'block',
        }));
        const iconMaskStyle = computed(() => ({
            display: 'inline-block',
            width: '100%',
            height: '100%',
            backgroundColor: '#000',
            WebkitMaskImage: `url(${downloadIconUrl})`,
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskImage: `url(${downloadIconUrl})`,
            maskRepeat: 'no-repeat',
            maskPosition: 'center',
            maskSize: 'contain',
        }));
        const triggerTextStyle = computed(() => ({
            fontSize: '16px',
            lineHeight: 1,
            fontWeight: 600,
            display: 'inline-flex',
            alignItems: 'center',
        }));
        const titleRowStyle = computed(() => ({
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
            minWidth: 0,
        }));
        const helpBtnStyle = computed(() => ({
            width: '34px',
            height: '24px',
            minWidth: '34px',
            minHeight: '34px',
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            border: `1px solid ${isHelpHovered.value ? '#d1d5db' : '#e5e7eb'}`,
            background: isHelpHovered.value ? '#e5e7eb' : '#f3f4f6',
            cursor: 'pointer',
            outline: 'none',
        }));
        const helpIconWrapStyle = computed(() => ({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '22px',
            height: '22px',
            borderRadius: '9999px',
            backgroundColor: 'transparent',
        }));
        const helpContentStyle = computed(() => ({
            minWidth: '260px',
            maxWidth: 'min(760px, calc(100vw - 64px))',
            maxHeight: 'min(70vh, 560px)',
            overflowY: 'auto',
            padding: '12px 14px',
            borderRadius: '10px',
            background: '#111827',
            color: '#fff',
            fontSize: '13px',
            lineHeight: 1.5,
            boxShadow: '0 12px 28px rgba(0,0,0,.2)',
            cursor: 'pointer',
        }));
        const wrapStyle = computed(() => ({
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            flexDirection: 'column',
            rowGap: '16px',
            overflow: 'hidden',
        }));
        const hintStyle = computed(() => ({
            color: '#111827',
            fontSize: '14px',
            lineHeight: 1.4,
            fontWeight: 700,
            margin: 0,
            marginBottom: '10px',
        }));
        const placeholderOverlayStyle = computed(() => ({
            position: 'absolute',
            inset: '0 auto auto 0',
            padding: '14px 16px',
            color: '#9ca3af',
            pointerEvents: 'none',
            whiteSpace: 'pre-line',
            lineHeight: 1.5,
            font: 'inherit',
            background: 'transparent',
            maxWidth: '100%',
            boxSizing: 'border-box',
            zIndex: 1,
        }));
        const placeholderText = computed(() => {
            return t('placeholder').replace(/__AT__/g, '@');
        });
        const helpTitleStyle = computed(() => ({
            margin: 0,
            marginBottom: '6px',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: 1.3,
            color: '#ffffff',
        }));
        const helpPStyle = computed(() => ({
            margin: 0,
            marginBottom: '10px',
            color: '#e5e7eb',
            fontSize: '13.5px',
        }));
        const helpListStyle = computed(() => ({
            margin: 0,
            paddingLeft: '18px',
            display: 'grid',
            rowGap: '6px',
            color: '#f3f4f6',
            fontSize: '14px',
            lineHeight: 1.45,
            listStyle: 'disc',
        }));
        const helpItemLabelStyle = computed(() => ({
            fontWeight: 700,
            color: '#ffffff',
        }));
        const helpFootStyle = computed(() => ({
            marginTop: '10px',
            color: '#9ca3af',
            fontSize: '12.5px',
            lineHeight: 1.4,
        }));
        const taWrapStyle = computed(() => ({
            position: 'relative',
        }));
        const textareaStyle = computed(() => {
            const baseBorderColor = '#dee2e6';
            const hoverBorderColor = '#afb9c3';
            const focusColor = '#2563eb';
            const borderColor = textareaFocused.value
                ? focusColor
                : textareaHovered.value
                    ? hoverBorderColor
                    : baseBorderColor;
            const boxShadow = textareaFocused.value
                ? '0 0 0 1px rgba(37, 99, 235, 0.3)'
                : 'none';
            return {
                display: 'block',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                height: '300px',
                resize: 'none',
                overflowY: 'auto',
                padding: '14px 16px',
                borderRadius: '6px',
                border: `1px solid ${borderColor}`,
                fontSize: '16px',
                lineHeight: '22px',
                fontFamily: SYSTEM_FONT_STACK,
                color: 'inherit',
                outline: 'none',
                boxShadow,
                backgroundColor: '#ffffff',
                transition: 'border-color 0.12s ease, box-shadow 0.12s ease',
            };
        });
        const hintRowStyle = computed(() => ({
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            marginBottom: '8px',
        }));
        const hintLabelStyle = computed(() => ({
            margin: 0,
            color: '#98a4b1',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: 1.42857143,
            fontFamily: SYSTEM_FONT_STACK,
        }));
        const charCounterStyle = computed(() => ({
            marginLeft: '12px',
            color: '#98a4b1',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 1.16666667,
            fontFamily: SYSTEM_FONT_STACK,
        }));
        const actionsStyle = computed(() => ({
            display: 'flex',
            alignItems: 'center',
            columnGap: '12px',
            marginTop: '6px',
        }));
        const orderLinkStyle = computed(() => ({ marginLeft: 'auto' }));
        const pendingBlockStyle = computed(() => ({
            border: '1px solid #d1d5db',
            borderRadius: '12px',
            padding: '12px 16px',
            background: '#f9fafb',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '12px',
            marginTop: '12px',
        }));
        const pendingTitleStyle = computed(() => ({
            fontWeight: 600,
            fontSize: '14px',
        }));
        const pendingTableStyle = computed(() => ({
            width: '100%',
            borderCollapse: 'collapse',
            background: '#fff',
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e5e7eb',
        }));
        const pendingHeadCellStyle = computed(() => ({
            textAlign: 'left',
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: '#6b7280',
            background: '#f3f4f6',
            padding: '8px 12px',
            borderBottom: '1px solid #e5e7eb',
        }));
        const pendingCellLabelStyle = computed(() => ({
            padding: '8px 12px',
            fontWeight: 500,
            fontSize: '13px',
            borderBottom: '1px solid #f3f4f6',
            verticalAlign: 'top',
        }));
        const pendingCellValueStyle = computed(() => ({
            padding: '8px 12px',
            fontSize: '13px',
            borderBottom: '1px solid #f3f4f6',
            color: '#111827',
            lineHeight: 1.45,
            verticalAlign: 'top',
            whiteSpace: 'pre-wrap',
        }));
        const noteStyle = computed(() => ({
            margin: 0,
            fontSize: '13px',
            lineHeight: 1.45,
            color: '#374151',
        }));
        /* Прелоадер */
        const loaderWrapStyle = computed(() => ({
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            marginTop: '8px',
            padding: '10px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            background: '#f9fafb',
        }));
        const spinnerStyle = computed(() => ({
            width: '18px',
            height: '18px',
            display: 'inline-block',
        }));
        const loaderTextStyle = computed(() => ({
            fontSize: '13px',
            color: '#374151',
        }));
        const pendingRows = computed(() => {
            const fieldRows = pendingFields.value.map((entry, index) => ({
                id: `field-${index}-${entry.key}`,
                label: entry.label,
                value: entry.value,
            }));
            const itemRows = pendingItems.value.map((item, index) => ({
                id: `item-${index}-${pendingItemKey(item)}`,
                label: t('pendingItemLabel', { index: index + 1 }),
                value: formatPendingItem(item),
            }));
            return [...fieldRows, ...itemRows];
        });
        const hasPendingChanges = computed(() => isExistingOrder.value && pendingAi.value !== null && pendingRows.value.length > 0);
        const canApplyPending = computed(() => hasPendingChanges.value && pendingChangedKeys.value.length > 0);
        const applyControlsStyle = computed(() => ({
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flexWrap: 'wrap',
        }));
        const applyNoteStyle = computed(() => ({
            fontSize: '12px',
            lineHeight: 1.4,
            color: '#4b5563',
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UiToolbarButton), {
                    appearance: "primary",
                    size: "sm",
                    locked: loading.value,
                    disabled: loading.value,
                    type: "button",
                    onClick: open,
                    style: _normalizeStyle(triggerBtnStyle.value)
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", {
                            style: _normalizeStyle(triggerContentStyle.value)
                        }, [
                            _createElementVNode("span", {
                                style: _normalizeStyle(triggerIconStyle.value),
                                "aria-hidden": "true"
                            }, [
                                _createElementVNode("span", {
                                    style: _normalizeStyle(iconMaskStyle.value)
                                }, null, 4 /* STYLE */)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", {
                                style: _normalizeStyle(triggerTextStyle.value)
                            }, _toDisplayString(_unref(t)('button')), 5 /* TEXT, STYLE */)
                        ], 4 /* STYLE */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["locked", "disabled", "style"]),
                _createVNode(_unref(UiModalSidebar), {
                    opened: opened.value,
                    closable: true,
                    "onUpdate:opened": _cache[8] || (_cache[8] = ($event) => (opened.value = $event)),
                    onClose: close,
                    size: "full"
                }, {
                    title: _withCtx(() => [
                        _createElementVNode("div", {
                            style: _normalizeStyle(titleRowStyle.value)
                        }, [
                            _createElementVNode("span", null, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                            _createVNode(_unref(UiPopperConnector), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UiButton), {
                                        size: "sm",
                                        appearance: "secondary",
                                        style: _normalizeStyle(helpBtnStyle.value),
                                        type: "button",
                                        "aria-label": _unref(t)('help.ariaLabel'),
                                        title: _unref(t)('help.ariaLabel'),
                                        onMouseenter: _cache[0] || (_cache[0] = ($event) => (isHelpHovered.value = true)),
                                        onMouseleave: _cache[1] || (_cache[1] = ($event) => (isHelpHovered.value = false)),
                                        onClick: openHelpLink
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", {
                                                style: _normalizeStyle(helpIconWrapStyle.value)
                                            }, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    style: _normalizeStyle(helpIconSvgStyle.value),
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    "aria-hidden": "true"
                                                }, [
                                                    _createElementVNode("path", {
                                                        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Z",
                                                        fill: isHelpHovered.value ? '#2563eb' : '#9ca3af'
                                                    }, null, 8 /* PROPS */, _hoisted_1),
                                                    _cache[9] || (_cache[9] = _createElementVNode("path", {
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M13 17.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1Zm.88-5.21a2.89 2.89 0 0 0 2-2.73V9A2.88 2.88 0 0 0 13 6.12h-2A2.88 2.88 0 0 0 8.12 9v.5a.5.5 0 0 0 .5.5h.76a.5.5 0 0 0 .5-.5V9c0-.619.501-1.12 1.12-1.12h2A1.12 1.12 0 0 1 14.16 9v.56a1.13 1.13 0 0 1-.76 1.07l-.95.31a1.88 1.88 0 0 0-1.29 1.78v.78a.5.5 0 0 0 .5.5h.76a.5.5 0 0 0 .5-.5v-.78c0-.053.032-.1.08-.12l.88-.31Z",
                                                        fill: "#ffffff"
                                                    }, null, -1 /* CACHED */))
                                                ], 4 /* STYLE */))
                                            ], 4 /* STYLE */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["style", "aria-label", "title"]),
                                    _createVNode(_unref(UiTooltip), {
                                        placement: "bottom-end",
                                        withArrow: true,
                                        offsetMainAxis: 10,
                                        offsetCrossAxis: 0,
                                        popperTriggers: ['hover'],
                                        container: "body",
                                        strategy: "fixed"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("section", {
                                                style: _normalizeStyle(helpContentStyle.value),
                                                role: "tooltip",
                                                "aria-live": "polite"
                                            }, [
                                                _createElementVNode("h3", {
                                                    style: _normalizeStyle(helpTitleStyle.value)
                                                }, _toDisplayString(_unref(t)('help.title')), 5 /* TEXT, STYLE */),
                                                _createElementVNode("p", {
                                                    style: _normalizeStyle(helpPStyle.value)
                                                }, _toDisplayString(_unref(t)('help.intro')), 5 /* TEXT, STYLE */),
                                                _createElementVNode("ul", {
                                                    style: _normalizeStyle(helpListStyle.value)
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(helpList.value, (row, i) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: i }, [
                                                            _createElementVNode("span", {
                                                                style: _normalizeStyle(helpItemLabelStyle.value)
                                                            }, _toDisplayString(row.label), 5 /* TEXT, STYLE */),
                                                            (row.tail)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, ": " + _toDisplayString(row.tail), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 4 /* STYLE */),
                                                _createElementVNode("p", {
                                                    style: _normalizeStyle(helpFootStyle.value)
                                                }, _toDisplayString(_unref(t)('help.footer')), 5 /* TEXT, STYLE */)
                                            ], 4 /* STYLE */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ], 4 /* STYLE */)
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            style: _normalizeStyle(wrapStyle.value)
                        }, [
                            _createElementVNode("div", {
                                style: _normalizeStyle(hintRowStyle.value)
                            }, [
                                _createElementVNode("div", {
                                    style: _normalizeStyle(hintLabelStyle.value)
                                }, _toDisplayString(_unref(t)('label')), 5 /* TEXT, STYLE */),
                                _createElementVNode("span", {
                                    style: _normalizeStyle(charCounterStyle.value)
                                }, _toDisplayString(_unref(n)(text.value.length)) + "/2000 ", 5 /* TEXT, STYLE */)
                            ], 4 /* STYLE */),
                            _createElementVNode("div", {
                                style: _normalizeStyle(taWrapStyle.value)
                            }, [
                                _createElementVNode("textarea", {
                                    maxlength: "2000",
                                    onInput: onTextChange,
                                    onKeydown: onKeydown,
                                    style: _normalizeStyle(textareaStyle.value),
                                    placeholder: "",
                                    onMouseenter: _cache[2] || (_cache[2] = ($event) => (textareaHovered.value = true)),
                                    onMouseleave: _cache[3] || (_cache[3] = ($event) => (textareaHovered.value = false)),
                                    onFocus: _cache[4] || (_cache[4] = ($event) => (textareaFocused.value = true)),
                                    onBlur: _cache[5] || (_cache[5] = ($event) => (textareaFocused.value = false))
                                }, null, 36 /* STYLE, NEED_HYDRATION */),
                                (!text.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        style: _normalizeStyle(placeholderOverlayStyle.value)
                                    }, _toDisplayString(placeholderText.value), 5 /* TEXT, STYLE */))
                                    : _createCommentVNode("v-if", true)
                            ], 4 /* STYLE */),
                            (isExistingOrder.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: _normalizeStyle(toggleRowStyle.value)
                                }, [
                                    _createVNode(_unref(UiCheckbox), {
                                        model: fillOnly.value,
                                        "onUpdate:model": _cache[6] || (_cache[6] = ($event) => ((fillOnly).value = $event)),
                                        disabled: loading.value,
                                        name: "aiot-fill-only"
                                    }, null, 8 /* PROPS */, ["model", "disabled"]),
                                    _createElementVNode("span", {
                                        style: _normalizeStyle(toggleTextStyle.value),
                                        onClick: _cache[7] || (_cache[7] = ($event) => (!loading.value && (fillOnly.value = !fillOnly.value)))
                                    }, _toDisplayString(_unref(t)('fillOnlyToggle')), 5 /* TEXT, STYLE */)
                                ], 4 /* STYLE */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", {
                                style: _normalizeStyle(actionsStyle.value)
                            }, [
                                _createVNode(_unref(UiButton), {
                                    appearance: "primary",
                                    size: "sm",
                                    locked: loading.value,
                                    disabled: loading.value,
                                    type: "button",
                                    onClick: send
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(primaryBtnText.value), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["locked", "disabled"]),
                                _createVNode(_unref(UiButton), {
                                    appearance: "secondary",
                                    size: "sm",
                                    type: "button",
                                    onClick: close
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                (orderUrl.value && !fillOnly.value)
                                    ? (_openBlock(), _createBlock(_unref(UiLink), {
                                        key: 0,
                                        href: orderUrl.value,
                                        style: _normalizeStyle(orderLinkStyle.value)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('openOrder')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["href", "style"]))
                                    : _createCommentVNode("v-if", true)
                            ], 4 /* STYLE */),
                            (loading.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    style: _normalizeStyle(loaderWrapStyle.value),
                                    role: "status",
                                    "aria-live": "polite"
                                }, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        style: _normalizeStyle(spinnerStyle.value),
                                        viewBox: "0 0 24 24",
                                        "aria-hidden": "true",
                                        focusable: "false"
                                    }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
                                            return _createElementVNode("g", {
                                                key: n,
                                                transform: `rotate(${(n - 1) * 30} 12 12)`
                                            }, [
                                                _createElementVNode("rect", {
                                                    x: "11",
                                                    y: "1.5",
                                                    width: "2",
                                                    height: "5.5",
                                                    rx: "1",
                                                    fill: spinnerColor
                                                }, [
                                                    _createElementVNode("animate", {
                                                        attributeName: "opacity",
                                                        values: "1;.2;1",
                                                        dur: "1s",
                                                        begin: `${(n - 1) * 0.083}s`,
                                                        repeatCount: "indefinite"
                                                    }, null, 8 /* PROPS */, _hoisted_4)
                                                ])
                                            ], 8 /* PROPS */, _hoisted_3);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ], 4 /* STYLE */)),
                                    _createElementVNode("span", {
                                        style: _normalizeStyle(loaderTextStyle.value)
                                    }, _toDisplayString(_unref(t)('loading')), 5 /* TEXT, STYLE */)
                                ], 4 /* STYLE */))
                                : _createCommentVNode("v-if", true),
                            (hasPendingChanges.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    style: _normalizeStyle(pendingBlockStyle.value)
                                }, [
                                    _createElementVNode("div", {
                                        style: _normalizeStyle(pendingTitleStyle.value)
                                    }, _toDisplayString(_unref(t)('pendingTitle')), 5 /* TEXT, STYLE */),
                                    _createElementVNode("table", {
                                        style: _normalizeStyle(pendingTableStyle.value)
                                    }, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", {
                                                    style: _normalizeStyle(pendingHeadCellStyle.value)
                                                }, _toDisplayString(_unref(t)('pendingColumnField')), 5 /* TEXT, STYLE */),
                                                _createElementVNode("th", {
                                                    style: _normalizeStyle(pendingHeadCellStyle.value)
                                                }, _toDisplayString(_unref(t)('pendingColumnValue')), 5 /* TEXT, STYLE */)
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingRows.value, (row) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: row.id
                                                }, [
                                                    _createElementVNode("td", {
                                                        style: _normalizeStyle(pendingCellLabelStyle.value)
                                                    }, _toDisplayString(row.label), 5 /* TEXT, STYLE */),
                                                    _createElementVNode("td", {
                                                        style: _normalizeStyle(pendingCellValueStyle.value)
                                                    }, _toDisplayString(row.value), 5 /* TEXT, STYLE */)
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ], 4 /* STYLE */),
                                    _createElementVNode("div", {
                                        style: _normalizeStyle(applyControlsStyle.value)
                                    }, [
                                        _createVNode(_unref(UiButton), {
                                            appearance: "secondary",
                                            size: "sm",
                                            type: "button",
                                            disabled: !canApplyPending.value || loading.value,
                                            locked: loading.value,
                                            onClick: applyPendingItems
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(t)('loadItems')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled", "locked"]),
                                        _createElementVNode("span", {
                                            style: _normalizeStyle(applyNoteStyle.value)
                                        }, _toDisplayString(_unref(t)('applyHint')), 5 /* TEXT, STYLE */)
                                    ], 4 /* STYLE */)
                                ], 4 /* STYLE */))
                                : _createCommentVNode("v-if", true),
                            (fillOnly.value && fillNote.value)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 3,
                                    style: _normalizeStyle(noteStyle.value)
                                }, _toDisplayString(fillNote.value), 5 /* TEXT, STYLE */))
                                : _createCommentVNode("v-if", true),
                            (error.value)
                                ? (_openBlock(), _createBlock(_unref(UiError), {
                                    key: 4,
                                    title: _unref(t)('errorTitle'),
                                    message: error.value
                                }, null, 8 /* PROPS */, ["title", "message"]))
                                : _createCommentVNode("v-if", true)
                        ], 4 /* STYLE */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["opened"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
